import { CheckCircleIcon, XCircleIcon, MinusCircleIcon } from '@heroicons/react/24/solid'

export default function DisplayActiveSuspended({ isActive, suspendedBy }) {
  if (!isActive && suspendedBy) {
    return (
      <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-red-50 border border-red-200">
        <XCircleIcon className="w-4 h-4 text-red-600" />
        <span className="text-sm font-medium text-red-700">Suspended</span>
      </div>
    )
  }

  if (!isActive) {
    return (
      <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-neutral-200-50 border border-gray-200">
        <MinusCircleIcon className="w-4 h-4 text-gray-500" />
        <span className="text-sm font-medium text-gray-600">Inactive</span>
      </div>
    )
  }

  return (
    <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-green-50 border border-green-200">
      <CheckCircleIcon className="w-4 h-4 text-green-600" />
      <span className="text-sm font-medium text-green-700">Active</span>
    </div>
  )
}
